import React from 'react';
import MainHeading from '../Common/MainHeading';
import { useLocale } from '../../localization/LocaleContext';
import './Testimonial.css';

const testimonialKeys = ['t1', 't2', 't3'];

export default function Testimonial(){
    const { t } = useLocale();
    return(
        <section className="testimonial-section sp-90">
            <div className="container">
                <MainHeading headingName={t('testimonials.heading')} />
                <div className="row spt-60">
                    {testimonialKeys.map((key) => (
                        <div className="col-lg-4" key={key}>
                            <div className="testimonial-card">
                                <div className="testimonial-stars">
                                    {'★★★★★'}
                                </div>
                                <p className="testimonial-quote">
                                    "{t(`testimonials.${key}.quote`)}"
                                </p>
                                <div className="testimonial-author">
                                    <div className="testimonial-avatar">
                                        {t(`testimonials.${key}.name`).charAt(0)}
                                    </div>
                                    <div>
                                        <p className="testimonial-name">{t(`testimonials.${key}.name`)}</p>
                                        <p className="testimonial-role">{t(`testimonials.${key}.role`)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}